
export class FreebieRequest {
    freebieId: number;
    freebieCategory: string;
    unitPrice: number;
    description: string;
    companyId: number;
    departmentId: number;
    freebieCode: string;
    startHour: number;
    startMinutes: number;
    endHour: number;
    endMinutes: number;
    username: string;
    startTime : Date;
    endTime : Date;
    isActive: boolean;

    /**
     * 
     * @param freebieId 
     * @param freebieCategory 
     * @param unitPrice 
     * @param freebieDesc 
     * @param companyId 
     * @param departmentId 
     * @param freebieCode 
     * @param startHour 
     * @param startMinutes 
     * @param endHour 
     * @param endMinutes 
     * @param username 
     * @param startTime 
     * @param endTime 
     * @param isActive boolean
     * 
     */
    constructor(freebieId: number, freebieCategory: string, unitPrice: number, description: string, companyId: number, departmentId: number, freebieCode: string, startHour: number, startMinutes: number, endHour: number, endMinutes: number, username: string,startTime:Date,endTime:Date,isActive: boolean) {
        this.freebieId = freebieId;
        this.freebieCategory = freebieCategory;
        this.unitPrice = unitPrice;
        this.description = description;
        this.companyId = companyId;
        this.departmentId = departmentId;
        this.freebieCode = freebieCode;
        this.startHour = startHour;
        this.startMinutes = startMinutes;
        this.endHour = endHour;
        this.endMinutes = endMinutes;
        this.username = username;
        this.startTime = startTime;
        this.endTime = endTime;
        this.isActive = isActive;
       }
}